const HawaiiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111580)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 40C25.0716 40 29.7015 38.1113 33.227 35H6.77295C10.2985 38.1113 14.9283 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M0.630371 25.0002C1.08701 26.7741 1.78123 28.4526 2.67654 30.0002H37.324C38.2193 28.4526 38.9135 26.7741 39.3701 25.0002L20.0003 23.4785L0.630371 25.0002Z"
        fill="#0052B4"
      />
      <path
        d="M39.3706 15C38.914 13.2261 38.2198 11.5477 37.3245 10L20.0007 9.56523C20.0007 6.07203 20.0007 2.7707 20.0007 0C18.515 0 17.067 0.162109 15.6737 0.469375C15.647 0.475313 2.60938 10.7592 2.60938 20C2.94273 20.058 20.0007 21.7391 20.0007 21.7391C20.0007 21.7391 20.0007 17.9297 20.0007 15H39.3706Z"
        fill="#0052B4"
      />
      <path
        d="M20 12.4783V2.47828H13.666L15.6736 0.470703C7.43211 2.28836 1.09969 9.18867 0.130469 17.7174C0.0453125 18.4666 0 19.228 0 20H10.1305V16.0138L14.1561 20H21.3112L13.6659 12.4783H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0091 19.999L12.4874 12.4773H10.1305V12.4774L17.6521 19.999H7.60867V9.99902H37.3237C36.2348 8.11676 34.8475 6.42895 33.2271 4.99902H7.60867V4.30176C5.59086 5.89684 3.88836 7.87246 2.60867 10.1204V19.999H0C0 21.7255 0.21875 23.401 0.630078 24.999H39.3699C39.7812 23.4009 40 21.7255 40 19.999H20.0091Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111580">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default HawaiiSvg;
